import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "fixed", "divider", "mode", "noTopPadding", "children", "fullWidth"];
import React, { useContext } from 'react';
import classNames from 'classnames';
import Context from "../common/context";
var PageFooter = function PageFooter(props) {
  var _classNames;
  var className = props.className,
    fixed = props.fixed,
    divider = props.divider,
    mode = props.mode,
    noTopPadding = props.noTopPadding,
    children = props.children,
    fullWidth = props.fullWidth,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var _useContext = useContext(Context),
    prefix = _useContext.prefix;
  var clsPrefix = prefix + "page-footer";
  var footerCls = classNames(className, (_classNames = {}, _classNames[clsPrefix + "--dividing"] = divider, _classNames[prefix + "page-footer"] = true, _classNames[prefix + "page-footer-fixed"] = fixed, _classNames[clsPrefix + "--no-top-padding"] = noTopPadding, _classNames[clsPrefix + "--fullwidth"] = fullWidth, _classNames[prefix + "bg--" + mode] = !!mode, _classNames));
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("footer", _extends({}, others, {
    className: footerCls
  }), /*#__PURE__*/React.createElement("div", {
    className: prefix + "page-footer-inner"
  }, children));
};
PageFooter.displayName = 'Footer';
PageFooter.typeMark = 'Footer';
PageFooter.defaultProps = {
  noTopPadding: false,
  divider: false,
  fullWidth: false,
  mode: 'surface'
};
export default PageFooter;